<template>
  <article class="chart box">
    <header class="chart__header">
      <div class="chart__header-left">
        <h2 class="chart__title title-24">
          <slot name="header"></slot>
        </h2>
        <p class="chart__subtitle">
          <slot name="subtitle"></slot>
        </p>
      </div>
      <div class="chart__header-right">
        <slot name="header-right"></slot>
      </div>
    </header>
    <div class="chart__content">
      <slot name="default"></slot>
    </div>
    <footer class="chart__footer">
      <slot name="footer"></slot>
    </footer>
  </article>
</template>

<style lang="scss" scoped>
.chart__header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.chart__header--with-indicatos {
  display: grid;
  grid-template-columns: 1fr min-content;
  gap: 35px;
}

.chart__subtitle {
  margin: 0;
  margin-top: 5px;
  font-size: 16px;
  color: var(--secondary-blue-darker);
}

.chart__content {
  width: 100%;
}

.chart__footer {
  margin-top: 40px;
}
</style>
